// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:19
import { AlarmInfo_abstract } from './../abstract/SagaBase/AlarmInfo_abstract';
export class AlarmInfo extends AlarmInfo_abstract {}
